import { ScoutHost } from "generated-graphql/graphql";
import { createContext, useContext, type PropsWithChildren } from "react";

export type ScoutHostContextValue = {
  host: ScoutHost;
  /** Dismiss popover without resetting conversation (representative handoff). */
  closeScout?: () => void;
};

const ScoutHostContext = createContext<ScoutHostContextValue>({ host: ScoutHost.FullPage });

export function ScoutHostProvider({
  value,
  children,
}: PropsWithChildren<{ value: ScoutHostContextValue }>) {
  return <ScoutHostContext.Provider value={value}>{children}</ScoutHostContext.Provider>;
}

export function useScoutHostContext(): ScoutHostContextValue {
  return useContext(ScoutHostContext);
}
